'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Selectors


// Components


// Measurements


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _lineUtil = require('./lineUtil');

var _lineControlPointUtil = require('./lineControlPointUtil');

var _rect = require('../../../common/maths/geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _elementSelector = require('../elementSelector');

var _lineSelector = require('./lineSelector');

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO Return only the required measurements (the ones that the line edges require)
var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
    };
};

var makeGetUpdatedLinePointsOfInterest = function makeGetUpdatedLinePointsOfInterest() {
    return (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, function (state, ownProps) {
        return ownProps.offsetDiff;
    }, function (_ref, control, offsetDiff) {
        var startEdgeOrigin = _ref.startEdgeOrigin,
            startConnectionRect = _ref.startConnectionRect,
            endEdgeOrigin = _ref.endEdgeOrigin,
            endConnectionRect = _ref.endConnectionRect;

        // Find the control point
        var controlPoint = (0, _lineSelector.getControlPosition)({ start: startEdgeOrigin, end: endEdgeOrigin, control: control });

        // If connected and the control point is halfway between the start and end origins, then we need to get
        // the updated control point
        var originLineMidpoint = (0, _lineControlPointUtil.getHalfwayPoint)(startEdgeOrigin, endEdgeOrigin);
        if ((startConnectionRect || endConnectionRect) && (pointLib.equals(originLineMidpoint, controlPoint) || rectLib.containsPoint(startConnectionRect, controlPoint) || rectLib.containsPoint(endConnectionRect, controlPoint))) {
            var originalPointsOfInterest = (0, _lineUtil.getLinePointsOfInterest)({
                startEdgeOrigin: startEdgeOrigin,
                startConnectionRect: startConnectionRect,
                endEdgeOrigin: endEdgeOrigin,
                endConnectionRect: endConnectionRect,
                controlPoint: controlPoint
            });
            controlPoint = originalPointsOfInterest.controlPoint;
        }

        controlPoint = pointLib.translate(controlPoint, offsetDiff);

        var isControlPointInStartElement = rectLib.containsPoint(startConnectionRect, controlPoint);
        var isControlPointInEndElement = rectLib.containsPoint(endConnectionRect, controlPoint);

        if (!isControlPointInStartElement && !isControlPointInEndElement) {
            controlPoint = (0, _lineControlPointUtil.snapControlPointIfClose)({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
        }

        // Use the line connecting from the end to the centre point of the start rect.
        var startVisibleConnectionPoint = (0, _lineUtil.getVisibleConnectionPoint)({
            sourcePoint: startEdgeOrigin,
            controlPoint: controlPoint,
            targetPoint: endEdgeOrigin,
            sourcePerimeter: startConnectionRect
        });
        var endVisibleConnectionPoint = (0, _lineUtil.getVisibleConnectionPoint)({
            sourcePoint: endEdgeOrigin,
            controlPoint: controlPoint,
            targetPoint: startEdgeOrigin,
            sourcePerimeter: endConnectionRect
        });

        if (pointLib.equals(originLineMidpoint, controlPoint)) {
            controlPoint = (0, _lineControlPointUtil.getHalfwayPoint)(startVisibleConnectionPoint, endVisibleConnectionPoint);
        } else if (isControlPointInStartElement) {
            controlPoint = startVisibleConnectionPoint;
        } else if (isControlPointInEndElement) {
            controlPoint = endVisibleConnectionPoint;
        }

        return {
            start: startVisibleConnectionPoint,
            end: endVisibleConnectionPoint,
            startEdgeOrigin: startEdgeOrigin,
            endEdgeOrigin: endEdgeOrigin,
            controlPoint: controlPoint
        };
    });
};

var makeMapStateToProps = function makeMapStateToProps() {
    return (0, _reselect.createSelector)(_elementSelector.getElementId, makeGetUpdatedLinePointsOfInterest(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (elementId, _ref2, colorHex, startStyle, endStyle, startSnapped, endSnapped) {
        var start = _ref2.start,
            end = _ref2.end,
            controlPoint = _ref2.controlPoint;
        return {
            elementId: elementId,
            start: start,
            end: end,
            colorHex: colorHex,
            startStyle: startStyle,
            endStyle: endStyle,
            startSnapped: startSnapped,
            endSnapped: endSnapped,
            controlPoint: controlPoint
        };
    });
};

var LineControlPointDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(LineControlPointDragPreview, _React$Component);

    function LineControlPointDragPreview() {
        _classCallCheck(this, LineControlPointDragPreview);

        return _possibleConstructorReturn(this, (LineControlPointDragPreview.__proto__ || Object.getPrototypeOf(LineControlPointDragPreview)).apply(this, arguments));
    }

    _createClass(LineControlPointDragPreview, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true, isSelected: true }));
        }
    }]);

    return LineControlPointDragPreview;
}(_react2.default.Component)) || _class) || _class);


LineControlPointDragPreview.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    offsetDiff: _propTypes2.default.object
};

exports.default = LineControlPointDragPreview;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/LineControlPointDragPreview.js
// module id = 1991
// module chunks = 0